// Italian locale date/time helpers — single source of truth.
// Store ISO (YYYY-MM-DD) internally; display GG/MM/AAAA everywhere.

const WEEKDAYS = ["Domenica", "Lunedì", "Martedì", "Mercoledì", "Giovedì", "Venerdì", "Sabato"];
const WEEKDAYS_SHORT = ["Dom", "Lun", "Mar", "Mer", "Gio", "Ven", "Sab"];
const MONTHS = ["Gennaio", "Febbraio", "Marzo", "Aprile", "Maggio", "Giugno", "Luglio", "Agosto", "Settembre", "Ottobre", "Novembre", "Dicembre"];
const MONTHS_SHORT = ["gen", "feb", "mar", "apr", "mag", "giu", "lug", "ago", "set", "ott", "nov", "dic"];

function parseISO(s) {
  if (!s) return null;
  if (s instanceof Date) return s;
  // support both YYYY-MM-DD and full ISO
  const d = new Date(s.length === 10 ? s + "T00:00:00" : s);
  return isNaN(d.getTime()) ? null : d;
}

// Primary display format: GG/MM/AAAA
export function formatDateIT(iso) {
  const d = parseISO(iso);
  if (!d) return "";
  const dd = String(d.getDate()).padStart(2, "0");
  const mm = String(d.getMonth() + 1).padStart(2, "0");
  return `${dd}/${mm}/${d.getFullYear()}`;
}

// Long form: Ven 05/09/2026
export function formatDateITLong(iso) {
  const d = parseISO(iso);
  if (!d) return "";
  return `${WEEKDAYS_SHORT[d.getDay()]} ${formatDateIT(iso)}`;
}

// Extra long: Venerdì 5 Settembre 2026
export function formatDateITFull(iso) {
  const d = parseISO(iso);
  if (!d) return "";
  return `${WEEKDAYS[d.getDay()]} ${d.getDate()} ${MONTHS[d.getMonth()]} ${d.getFullYear()}`;
}

export function todayISO() {
  return new Date().toISOString().slice(0, 10);
}

export function toISODate(d) {
  const yy = d.getFullYear();
  const mm = String(d.getMonth() + 1).padStart(2, "0");
  const dd = String(d.getDate()).padStart(2, "0");
  return `${yy}-${mm}-${dd}`;
}

export { WEEKDAYS, WEEKDAYS_SHORT, MONTHS, MONTHS_SHORT };
